<template>
  <ContactDetailsComponent
      :id="person.id"
      :avatar="person.avatar"
      :name="person.name"
      :subtitle="person.subtitle"
      :phone="person.phone"
      :email="person.email_address"
      :cta-uri="'/settings/entity/externalperson/' + person.id"
      :loading="loading"
  ></ContactDetailsComponent>
</template>

<script>
import ContactDetailsComponent from "~/components/ContactDetailsComponent.vue";
import externalPersonApi from "~/api/external_person";
import ExternalPersonTypeEnum from "~/enums/ExternalPersonTypeEnum";
import ExternalPersonTypeDisplayEnum from "~/display_enums/ExternalPersonTypeDisplayEnum";

export default {
  name: "ExternalPersonContactDetailsComponent",
  components: {
    ContactDetailsComponent,
    externalPersonApi,
    ExternalPersonTypeEnum,
    ExternalPersonTypeDisplayEnum,
  },
  props: {
    id: {
      type: [Number, String],
      required: false,
      default: null,
    },
    /** For future purpose, when used in other Vue component */
    // externalPerson: {
    //   type: [Object],
    //   required: false,
    //   default: () => {
    //   }
    // },
  },
  created() {
    /** For future purpose, when used in other Vue component */
    // if (this.id === null && this.externalPerson !== null && !this.isObjectEmpty(this.externalPerson)) {
    //   this.person = this.externalPerson;
    //   this.mapSubtitleByTypeViaEnum()
    //   this.loading = false
    // } else if

    if (this.id !== null && this.id !== '' && this.id !== undefined) {
      this.getContactDetails()
    }
  },
  data() {
    return {
      loading: false,
      person: {
        id: null,
        avatar: null,
        name: null,
        subtitle: null,
        phone: null,
        email_address: null,
      },
    };
  },
  methods: {
    isObjectEmpty(objectName) {
      return Object.keys(objectName).length === 0 && objectName.constructor === Object;
    },
    getContactDetails() {
      this.loading = true;

      externalPersonApi.findById(this.id).then((response) => {
        this.person = response.data
        this.mapSubtitleByTypeViaEnum()
      }).finally(() => {
        this.loading = false;
      })
    },
    mapSubtitleByTypeViaEnum() {
      if (this.person !== null
          && this.person.hasOwnProperty('type')
          && Object.values(ExternalPersonTypeEnum).includes(this.person.type)
      ) {
        let typeEnum = this.getKeyByValue(ExternalPersonTypeEnum, this.person.type)

        this.person.subtitle = typeEnum in ExternalPersonTypeDisplayEnum ? ExternalPersonTypeDisplayEnum[typeEnum] : null
      }
    },
    getKeyByValue(object, value) {
      return Object.keys(object).find(key => object[key] === value);
    },
  },
}
</script>

<style scoped>

</style>